import { DataAttributesProps, FooterItemProp, FooterLinkProps } from '@/store/types/IBuilder';
import { GenericGaProps } from './gaTypes';

// The type of item is kept loose (any) not to break anything but should be reviewed and fixed
export const getDataAttributes = (item: FooterItemProp | FooterLinkProps | GenericGaProps | any | undefined) => {
  if (!item?.gaEvents) return {};

  return item.gaEvents.reduce(
    (dataEvents, gaEvent, index) => {
      if (!gaEvent.dataAttributes) return dataEvents;

      const attributes = gaEvent.dataAttributes.reduce((attrs, { dataAttributeName, dataAttributeValue }) => {
        const key = `data-event${index + 1}-${dataAttributeName}`;
        return { ...attrs, [key]: dataAttributeValue };
      }, {});

      return { ...dataEvents, ...attributes };
    },
    {} as Record<string, string>
  );
};

export const findDataAttributeValue = (
  attributes: DataAttributesProps[],
  attributeName: string
): string | undefined => {
  const lowerCaseAttributeName = attributeName.toLowerCase();
  const attribute = attributes.find(attr => attr.dataAttributeName.toLowerCase() === lowerCaseAttributeName);
  return attribute?.dataAttributeValue;
};
